import binarySearchString from "../utils/binarySearchString";
import getBlockInformation from "../utils/getBlockInformation";
import TreeState from "../data/state/TreeState";

function TreeReducer(state, action) {

    switch (action.type) {
        case 'loadBotSuccess': {
            return {
                ...TreeState,
                fetching : false,
                blocks : action.payload.blocks,
                categories :action.payload.categories,
                children : action.payload.children,
                paths : action.payload.paths,
                blocksSelected : [],
                blocksVisible : [],
                pathsVisible : [],
            };
        }

        case 'setFetching': {
            return {
                ...TreeState,
                fetching : action.payload.fetching,
            };
        }

        case 'deleteBlock' : {
            const {block, paths_in, paths_out, position} = getBlockInformation(action.payload.id, state.blocks, state.paths);

            for(const path of paths_in) {
                let index = state.paths.findIndex( (_path) => _path.path_id == path.path_id)
                if( index !== -1) {
                    state.paths.splice(index, 1)
                }
                
                index = state.pathsVisible.findIndex( (_path) => _path.path_id == path.path_id)
                if( index !== -1) {
                    state.pathsVisible.splice(index, 1)
                }
            }

            for(const path of paths_out) {
                let index = state.paths.findIndex( (_path) => _path.path_id == path.path_id)
                if( index !== -1) {
                    state.paths.splice(index, 1)
                }

                index = state.pathsVisible.findIndex( (_path) => _path.path_id == path.path_id)
                if( index !== -1) {
                    state.pathsVisible.splice(index, 1)
                }
                
            }
            
            if(block.children) {
                for(const child of block.children) {
                    let index = binarySearchString(state.children, child.object_id, 'object_id');
                    if( index === null) {
                        continue
                    }
    
                    state.children.splice(index, 1);
                }
            }
            

            state.blocks.splice(position, 1);

            let index = binarySearchString(state.blocksVisible, block.object_id, 'object_id');
            state.blocksVisible.splice(index, 1);

            return {
                ...state,
            }
        }

        case 'updateBlockPosition': {
            const blockIndex = binarySearchString(state.blocks, action.payload.id, 'object_id');
            const blocks = [...state.blocks];
            // Fix for import block, sometimes the block update his position before link to another
            if(blocks[blockIndex] == undefined) return {...state};
            blocks[blockIndex].x = action.payload.x;
            blocks[blockIndex].y = action.payload.y;
            return {
                ...state, blocks 
            };
        }

        case 'updateBlockName': {
            const blockIndex = binarySearchString(state.blocks, action.payload.id, 'object_id');
            const blocks = [...state.blocks];
            blocks[blockIndex].name = action.payload.name;
            return {
                ...state, blocks 
            };
        }

        case 'updateBlockMagic': {
            const blockIndex = binarySearchString(state.blocks, action.payload.id, 'object_id');
            const blocks = [...state.blocks];
            blocks[blockIndex].data.jump_id = null;
            return {
                ...state, blocks 
            };
        }

        case 'updateBlockTypeAction': {
            const blockIndex = binarySearchString(state.blocks, action.payload.id, 'object_id');
            const blocks = [...state.blocks];
            blocks[blockIndex].action_type = action.payload.type;

            return {
                ...state, blocks 
            };
        }

        case 'updateBlockData': {
            const blockIndex = binarySearchString(state.blocks, action.payload.id, 'object_id');
            const blocks = [...state.blocks];
            blocks[blockIndex].data = {...blocks[blockIndex].data, ...action.payload.data};
            return {
                ...state, blocks 
            };
        }

        case 'updateBlockStatistics': {
            const blockIndex = binarySearchString(state.blocks, action.payload.id, 'object_id');
            const blocks = [...state.blocks];
            blocks[blockIndex].is_statistic = action.payload.is_statistic;
            return {
                ...state, blocks 
            };
        }

        case 'deletePath' : {
            let indexPath = state.paths.findIndex( (_path) => _path.path_id == action.payload.id);

            let indexPathVisible = state.pathsVisible.findIndex( (_path) => _path.path_id == action.payload.id);

            if( indexPath === -1 || indexPathVisible === -1) {
                return  {...state}
            }

            state.paths.splice(indexPath, 1)
            state.pathsVisible.splice(indexPathVisible, 1)

            return  {...state}
        }

        case 'updateBlockVisibility' : {
            return {...state, blocksVisible : [...action.payload.blocks], pathsVisible : [...action.payload.paths]}
        }

        case 'addBlock': {

            const block = {...action.payload.block}
            const children = [...action.payload.children]

            state.blocks.push(block);
            state.blocksVisible.push(block);
            for(var i = 0; i < children.length; i++) {
                state.children.push(children[i]);
            }
            
            return {
                ...state
            };
        }

        case 'createAndUpdateBlockChild' : {
            const newChild = {...action.payload.data};

            const blockIndex = binarySearchString(state.blocks, action.payload.block_id, 'object_id');
            
            state.blocks[blockIndex].children = [...state.blocks[blockIndex].children, newChild];
            state.blocks[blockIndex].children = state.blocks[blockIndex].children.map(child => child.object_id != action.payload.object_id ? child : {...child, index : state.blocks[blockIndex].children.length - 1})

            return {
                ...state
            };
        }

        case 'createBlockChildBeforeLast' : {
            const child = {...action.payload.data};

            const blockIndex = binarySearchString(state.blocks, action.payload.block_id, 'object_id');
            const blocks = [...state.blocks];
            const childrenBlocks = [...blocks[blockIndex].children];

            const last = childrenBlocks.pop();
            last.index = blocks[blockIndex].children.length;
            blocks[blockIndex].children = [...childrenBlocks, child, last]


            var childIndex = binarySearchString(state.children, last.object_id, 'object_id');
            var children = [...state.children];
            children[childIndex].index = last.index; 
            

            return {
                ...state, blocks : [...blocks], children : [...children, child]
            };
        }

        case 'createBlockChild' : {
            const child = {...action.payload.data};

            const blockIndex = binarySearchString(state.blocks, action.payload.block_id, 'object_id');
            const blocks = [...state.blocks];
            
            blocks[blockIndex].children = [...blocks[blockIndex].children, child]

            

            return {
                ...state, blocks, children : [...state.children, child]
            };
        }

        case 'updateBlockChild' : {

            const newChild = { ...action.payload.data }

            const blockIndex = binarySearchString(state.blocks, action.payload.block_id, 'object_id');
            const blocks = [...state.blocks];
            const childrenBlocks = [...blocks[blockIndex].children];

            blocks[blockIndex].children = childrenBlocks.map(child => child.object_id != action.payload.object_id ? child : {...child, ...newChild})

            var childIndex = binarySearchString(state.children, action.payload.object_id, 'object_id');
            var children = [...state.children];
            children[childIndex] = {...children[childIndex], ...newChild}; 

            return {
                ...state, blocks , children 
            };
        }

        case 'updateBlockChildren' : {
            const newChildren = [...action.payload.children];

            const blockIndex = binarySearchString(state.blocks, action.payload.block_id, 'object_id');
            const blocks = [...state.blocks];
            blocks[blockIndex].children = newChildren;

            const children = [...state.children];

            for(var i = 0; i < blocks[blockIndex].children.length; i++) {
                const indexChild = binarySearchString(children, blocks[blockIndex].children[i].object_id, 'object_id');
                if(indexChild == null) {
                    continue
                }
                children[indexChild].index = blocks[blockIndex].children[i].index
            }
            

            return {
                ...state, blocks, children
            };
        }

        case 'deleteBlockChild' : {

            const blockIndex = binarySearchString(state.blocks, action.payload.block_id, 'object_id');
            const blocks = [...state.blocks];
            
            const newChildren = blocks[blockIndex].children.filter(child => child.object_id != action.payload.object_id);
            blocks[blockIndex].children = [...newChildren];        

            return {
                ...state, blocks : [...blocks], children : [...newChildren]
            };
        }

        case 'deleteBlockChildAndOrderOther' : {

            const blockIndex = binarySearchString(state.blocks, action.payload.block_id, 'object_id');
            const blocks = [...state.blocks];
            
            blocks[blockIndex].children = blocks[blockIndex].children.filter(child => child.object_id != action.payload.object_id).map((child,index) => {return {...child, index : index }});        

            const children = [...state.children.filter(child => child.object_id != action.payload.object_id)];
            
            for(var i = 0; i < blocks[blockIndex].children.length; i++) {
                const indexChild = binarySearchString(children, blocks[blockIndex].children[i].object_id, 'object_id');
                children[indexChild].index = blocks[blockIndex].children[i].index
            }

            return {
                ...state, blocks, children
            };
        }

        case 'createPath' : {
            const path = {...action.payload};
            state.paths.push(path);
            state.pathsVisible.push(path);
            return {
                ...state
            };
        }

        case 'createCategory': {
            const infoCategory = {...action.payload};
            state.categories.push(infoCategory);
            let blocksInCategory = infoCategory.category.categories_blocks;
            for(var i = 0; i < blocksInCategory.length; i++) {
                let indexChild = binarySearchString(state.blocks, blocksInCategory[i].blocks.object_id, 'object_id');
                state.blocks[indexChild].bot_category_id = infoCategory.category.id;
            }
            return {
                ...state
            };
        }

        case 'updateCategory': {
            let indexCategory = state.categories.findIndex( (infoCategory) => infoCategory.category.id == action.payload.id);
            let categories = [...state.categories];
    
            let infoCategory = action.payload.category;
            categories[indexCategory] = infoCategory;

            let blocksInCategory = infoCategory.category.categories_blocks;
            for(var i = 0; i < blocksInCategory.length; i++) {
                let indexChild = binarySearchString(state.blocks, blocksInCategory[i].blocks.object_id, 'object_id');
                state.blocks[indexChild].bot_category_id = infoCategory.category.id;
            }
            return {
                ...state, categories 
            };
        }
        case 'deleteCategory': {
            let indexCategory = state.categories.findIndex( (infoCategory) => infoCategory.category.id == action.payload.id);
            if( indexCategory === -1) {
                return  {...state}
            }
            let categories = [...state.categories];
            let infoCategory = categories[indexCategory];
            let blocksInCategory = infoCategory.category.categories_blocks;
            for(var i = 0; i < blocksInCategory.length; i++) {
                let indexChild = binarySearchString(state.blocks, blocksInCategory[i].blocks.object_id, 'object_id');
                state.blocks[indexChild].bot_category_id = null;
            }
            state.categories.splice(indexCategory, 1)
            return  {...state}
        }
        case 'ungroupBlockFromCategory': {
            let indexCategory = state.categories.findIndex( (infoCategory) => infoCategory.category.id == action.payload.id);
            let categories = [...state.categories];

            if (categories[indexCategory].category?.categories_blocks.length - 1 == 0){
                state.categories.splice(indexCategory, 1)
                categories = [...state.categories] 
            }
            else{ // sinon on supprime le block dans la category blocks list
                categories[indexCategory] = action.payload.infoCategory;
            }
            // on supprime la category dans le block affilie
            let indexChild = binarySearchString(state.blocks, action.payload.block_object_id, 'object_id');
            state.blocks[indexChild].bot_category_id = null;
            return {
                ...state, categories 
            };
        }
        case 'setZoneSelectBlocks': {
            return {
                ...state,
                zoneSelectBlocks: { x : action.payload.x, y : action.payload.y }
            };
        }

        case 'setCtrlKey': {
            return {
                ...state,
                ctrlKey: action.payload.ctrlKey
            };
        }

        case 'setShiftKey': {
            return {
                ...state,
                shiftKey: action.payload.shiftKey
            };
        }

        case 'setPressDown': {
            return {
                ...state,
                pressDown: action.payload.pressDown
            };
        }

        case 'loadBotFailed': {
            return {
                ...state,
                fetching: false
            };
        }

        case 'loadBotPending': {
            return {
                ...state,
                fetching: true
            };
        }
        

        case 'resetState' : {
            return TreeState
        }
        
        default: {
            throw new Error('unhandled action');
        }
    }
}

export default TreeReducer;